import { create } from "zustand";
import { persist } from "zustand/middleware";

type PropertyProgressUiState = {
  collapsedByClientId: Record<string, boolean>;
  toggleCollapsed: (clientId: string) => void;
};

/** Per-client collapsed state for the portfolio progress band, persisted so a
 * returning user keeps their preference. Mirrors usePropertyPaginationStore. */
export const usePropertyProgressUiStore = create<PropertyProgressUiState>()(
  persist(
    (set) => ({
      collapsedByClientId: {},
      toggleCollapsed: (clientId) =>
        set((state) => ({
          collapsedByClientId: {
            ...state.collapsedByClientId,
            [clientId]: !state.collapsedByClientId[clientId],
          },
        })),
    }),
    { name: "property-progress-ui" },
  ),
);
